import { actionCreators as programItemsAC } from 'store/programItems';
import { REQUEST_PERSIST_SELECTION, REQUEST_TOGGLE_TOOLTIP } from './recipes.actionTypes';

export const actionCreators = {
	doPersistPortionSelection: (externalId: string, portionValue: number) => ({
		type: REQUEST_PERSIST_SELECTION,
		portionValue,
		externalId,
	}),
	doToggleTooltip: (externalId: string, dir: 'inc' | 'dec', visible: boolean) => ({
		type: REQUEST_TOGGLE_TOOLTIP,
		dir,
		visible,
		externalId,
	}),
};

export type RecipesActionType =
	| ReturnType<typeof actionCreators.doPersistPortionSelection>
	| ReturnType<typeof actionCreators.doToggleTooltip>
	| ReturnType<typeof programItemsAC.doReplaceItemContents>
	| ReturnType<typeof programItemsAC.doRequestProgramItemsContentsSuccess>;
